<div class="emds ap-message-thread">
  <div [ngClass]="i === messageThread.length - 1 ? '' : 'tile-margin'"
       *ngFor="let message of messageThread; index as i">
    <ap-message-thread-message [baseId]="baseId"
                               [message]="message">
    </ap-message-thread-message>
  </div>
</div>
